import { GridFilterModel, GridSortModel } from "@mui/x-data-grid-premium";
import { MarkedMeasurementLogDto } from "../../app/apislices/markedMeasurementLogApi";

export enum DataPlausibilityStatus {
  open = "open",
  used = "used",
  discarded = "discarded",
}

export const GermanDataPlausibilityStatus = { open: "offen", used: "verwendet", discarded: "verworfen" };

export interface DataPlausibilityState {
  sortModel: GridSortModel;
  filterModel: GridFilterModel;
  isFilterShowing: boolean;
  selectedStart: string;
  selectedEnd: string;
  selectedStatus: DataPlausibilityStatus[];
  graphDialogSelection: MarkedMeasurementLogDto | null;
}
